import React from 'react';

export default function GetFavoriteProducts() {
  return (
    <div>
      <h1>You are on the Favorites page. This will show the favorites for the current user who is logged in.
      </h1>
    </div>
  );
}
